export const dialogNames = {
  backupDialog: 'BackupDialog',
  connectionLostDialog: 'LinkDownMessage',
};
Object.freeze(dialogNames);
